import {v4 as uuidv4} from 'uuid';
import {getEnv} from '../../common/env/env';
import {RecommendEventVo} from '../../common/shared/api/nicolas/vo/RecommendEventVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {RecommendEvent} from '../generated/types';

export function createRecommendEvent({
  banner_uid,
  kage_id,
  scheme,
  item_order,
  title,
}: RecommendEventVo): RecommendEvent {
  return {
    id: uuidv4(),
    bannerUid: banner_uid,
    imageUrl: kage_id.startsWith('http')
      ? kage_id
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: kage_id,
          resolution: 'th3',
        }),
    itemOrder: item_order,
    title,
    scheme,
  };
}
